/* eslint-disable indent */
import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  createCustomPlayer,
  deleteCustomPlayer,
  initializePlayers,
} from '../reducers/playerReducer'
import { initializeUser } from '../reducers/userReducer'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'
import PlayerSorter from './PlayerSorter'
import CreateCustomPlayer from './CreateCustomPlayer'
import { decodeHtmlEntities } from '../services/helpfunctions'

const MY_PLAYERS_LOAD_ERROR_MESSAGE =
  'Ongelma pelaajalistan llataamisessa Hattrickista - jos ongelma toistuu, kirjaudu ulos ja takaisin sisään. Jos tämäkään ei auta, ota yhteyttä sivuston tekijään.'

const MyPlayers = () => {
  const dispatch = useDispatch()
  const players = useSelector(state => state.players.myPlayers)
  const myPlayersLoaded = useSelector(state => state.players.myPlayersLoaded)
  const user = useSelector(state => state.user)
  const [loadError, setLoadError] = useState('')
  useEffect(() => {
    // Jos pelaajat on jo ladattu Reduxiin, ei tehdä mitään
    if (myPlayersLoaded || loadError) return
    const loadData = async () => {
      try {
        setLoadError('')
        // Varmista että käyttäjä on ladattu, hae vain jos ei ole Reduxissa
        const userData = await dispatch(initializeUser())
        if (userData) {
          const token = userData.oauth_token || userData.id
          // Hae pelaajat vain jos ei ole jo Reduxissa
          await dispatch(initializePlayers(token))
        }
      } catch (error) {
        const backendMessage = error?.response?.data?.error
        setLoadError(backendMessage || MY_PLAYERS_LOAD_ERROR_MESSAGE)
      }
    }
    loadData()
  }, [myPlayersLoaded, loadError, dispatch])

  if (loadError) {
    return (
      <Alert variant="danger" className="m-3">
        {loadError}
      </Alert>
    )
  }

  // Tarkista että user on olemassa ennen teams-kentän käyttöä
  if (!user) {
    return (
      <Table striped bordered hover variant="dark" size="sm">
        <tbody>
          <tr>
            <td>
              <Spinner animation="border" />
            </td>
          </tr>
        </tbody>
      </Table>
    )
  }

  const userTeams = user.teams
  const customPlayers = players.filter(player => player.isCustom)
  const teamPlayers = players.filter(player => !player.isCustom)
  const hasStaffCreateAccess =
    user &&
    Array.isArray(user.staff) &&
    user.staff.some(
      staffRole =>
        staffRole &&
        (staffRole.role === 'Scout' || staffRole.role === 'HeadScout')
    )

  const handleCreateCustomPlayer = async playerData => {
    const token = user.oauth_token || user.id
    return await dispatch(createCustomPlayer(playerData, token))
  }

  const handleDeleteCustomPlayer = async customPlayerId => {
    const confirmed = window.confirm('Poistetaanko luotu pelaaja varmasti?')
    if (!confirmed) return
    const token = user.oauth_token || user.id
    await dispatch(deleteCustomPlayer(customPlayerId, token))
  }

  const playersInTeam = (list, teamName, teamId) => {
    if (list.length > 0) {
      return <PlayerSorter players={list} teamName={teamName} key={teamId} />
    }
    return null
  }

  const userTeamsList =
    user && userTeams && teamPlayers[0] && teamPlayers[0].owningTeam
      ? userTeams.map(id =>
          playersInTeam(
            teamPlayers.filter(
              player => Number(player.owningTeam.teamId) === Number(id.teamID)
            ),
            decodeHtmlEntities(id.teamName) || `Team ${id.teamID}`,
            id.teamID
          )
        )
      : []

  return userTeams ? (
    <>
      {hasStaffCreateAccess && (
        <CreateCustomPlayer
          oauthToken={user.oauth_token || user.id}
          onCreate={handleCreateCustomPlayer}
        />
      )}

      {userTeamsList}
      {customPlayers.length > 0 && (
        <PlayerSorter
          players={customPlayers}
          teamName="Luodut pelaajat"
          onRemove={handleDeleteCustomPlayer}
        />
      )}
    </>
  ) : (
    <Table striped bordered hover variant="dark" size="sm">
      <tbody>
        <tr>
          <td>
            <Spinner animation="border"></Spinner>
          </td>
        </tr>
      </tbody>
    </Table>
  )
}

export default MyPlayers
